import { BillingWorkspace } from '@/components/billing/billing-workspace'

export function OperationsBilling() {
  return <BillingWorkspace basePath="/operations/billing" />
}
